
const userTypes = [
    {
        type: 'artist',
        icon: '/assets/layout/images/icons/palette.svg',
        icon_active: '/assets/layout/images/icons/palette_white.svg',
        descr: 'global_text_artist'
    },
    {
        type: 'company',
        icon: '/assets/layout/images/icons/building.svg',
        icon_active: '/assets/layout/images/icons/building_white.svg',
        descr: 'global_text_company'
    },
    {
        type: 'artlover',
        icon: '/assets/layout/images/icons/heart.svg',
        icon_active: '/assets/layout/images/icons/heart_white.svg',
        descr: 'global_text_artlover'
    }
    ,
];

const userType = {
    artist: "artist",
    company: "company",
    artlover: "artlover",
}

const addTypes = [
    {
        type: 'artwork',
        icon: '/assets/layout/images/icons/artwork.svg',
        icon_active: '/assets/layout/images/icons/artwork_white.svg',
        descr: 'global_text_artwork'
    },
    {
        type: 'exhibits',
        icon: '/assets/layout/images/icons/exhibition.svg',
        icon_active: '/assets/layout/images/icons/exhibition_white.svg',
        descr: 'global_text_exhibits'
    }
    
];


const fileTypes = {
    artwork: "artwork",
    profile_photo: "profile_photo",
    profile_header: "profile_header",
    exhibition_cover : "exhibition_cover",

}


const entityNames = {
    artwork: "artwork",
    exhibition : "exhibition",
    artist:"artist",
    company:"company"
}

const exhibitionStatus = {
    ALL:-1,
    DRAFT:1,
    IN_REVIEW : 2,
    APPROVED : 3,
    EXPIRED : 4,
    REJECTED : 5,
    DELETED : 6,
    SCHEDULED:10,
    PUBLISHED:11,

}


const featuredExhibitionFilter = {
    favorites:"favorites",
    attended:"attended",
    own:"own",

}



const featuredExhibition = {
    first:"first",
    second:"second",
}

const favoriteFileType = {
    ALL:"ALL",
    exhibition:"exhibition",
    artwork:"artwork",
}

const searchType = {
    ARTWORKS : "ARTWORKS",
    ARTISTS : "ARTISTS",
    COMPANIES : "COMPANIES",
    EXHIBITS : "EXHIBITS",
}


const coverImages = [
   /* {
        image_path: '/assets/layout/images/temp/cover_1.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_2.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_3.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_4.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_5.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_6.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_7.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_8.jpg',
    },
    */{
        image_path: '/assets/layout/images/temp/cover_9.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_10.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_21.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_12.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_13.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_14.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_15.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_16.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_17.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_18.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_19.jpg',
    },
    /*{
        image_path: '/assets/layout/images/temp/cover_20.jpg',
    },
    {
        image_path: '/assets/layout/images/temp/cover_21.jpg',
    },*/
];

const Constants = {
    userType,
    userTypes,
    addTypes,
    fileTypes,
    coverImages,
    entityNames,
    exhibitionStatus,
    featuredExhibitionFilter,
    featuredExhibition,
    favoriteFileType,
    searchType,
};



export default Constants;